import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import { EVENTS_PATH } from "~produce/production/events/helpers/eventDefinitionsSsrmRow";

export const TASK_EVENT_TARGET_KIND = "productionTaskEvent";

export const TASK_EVENT_LIST_TARGET_KIND = "productionTaskEventList";

export const EVENTS_DOCK_PANEL_ID = "events";

const TASK_EVENT_ROUTE_PATTERN = /^\/produce\/production\/events\/([^/?#]+)$/;

export const matchTaskEventReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = TASK_EVENT_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind: TASK_EVENT_TARGET_KIND };
	} catch {
		return null;
	}
};

const taskEventReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${EVENTS_PATH}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchTaskEventReceiverRoute
};

export interface TaskEventListScope {
	laborTypeId: string;
	laborTypeName: string;
}

export const buildTaskEventListTarget = ({ laborTypeId, laborTypeName }: TaskEventListScope): ContinuationTarget => ({
	listFilters: { laborTypeId, laborTypeName },
	targetId: laborTypeId,
	targetKind: TASK_EVENT_LIST_TARGET_KIND
});

export const readTaskEventListScope = (listFilters: Record<string, string> | undefined): null | TaskEventListScope => {
	const laborTypeId = listFilters?.laborTypeId;
	const laborTypeName = listFilters?.laborTypeName;
	return laborTypeId && laborTypeName ? { laborTypeId, laborTypeName } : null;
};

export const taskEventListReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: () => EVENTS_PATH,
	matchesRoute: () => null
};

export default taskEventReceiverIdentityAdapter;
